import React from 'react'
import {
  faBuildingColumns,
  faCartShopping,
  faCheckDouble,
  faUpload,
  faWindowMaximize,
} from '@fortawesome/free-solid-svg-icons'
import { PixelCurrency, PixelIcon, PixelText, colors } from 'pixel-base'
import styled from 'styled-components'

const CardView = (props) => {
  const { color, data } = props
  data.map((item) => {
    item.orders = [
      {
        title: 'shipped',
        background: colors.grayLightBg,
        IconBackground: colors.grayLighter,
        logo: (
          <PixelIcon
            color={color}
            fontSize="19px"
            padding="10px 0 0 0"
            icon={faCartShopping}
          />
        ),
        totalrevenue: item.shipped_amount,
        total: item?.total_shipped,
      },
      {
        title: ' Delivered',
        background: colors.greenLightBg,
        IconBackground: colors.greenLighterBg,
        logo: (
          <PixelIcon
            color={color}
            fontSize="19px"
            padding="10px 0 0 0"
            icon={faCheckDouble}
          />
        ),
        totalrevenue: item.total_amount_delivered,
        total: item?.total_orders_delivered,
      },
      {
        title: 'Invoice Uploaded',
        background: colors.redLightBg,
        IconBackground: colors.redLighterBg,
        logo: (
          <PixelIcon
            color={color}
            fontSize="19px"
            padding="10px 0 0 0"
            icon={faUpload}
          />
        ),
        totalrevenue: item.received_amount_by_payment_invoices,
        total: '',
      },
      {
        title: 'Recieved in Banks',
        background: colors.greenLightBg,
        IconBackground: colors.greenLighterBg,
        logo: (
          <PixelIcon
            color={color}
            fontSize="19px"
            padding="10px 0 0 0"
            icon={faBuildingColumns}
          />
        ),
        totalrevenue: item.received_amount_by_bank_deposits,
        total: '',
      },
      {
        title: 'Amount Recieveable',
        background: colors.yellowLightBg,
        IconBackground: colors.yellowLighterBg,
        logo: (
          <PixelIcon
            color={color}
            fontSize="19px"
            padding="10px 0 0 0"
            icon={faWindowMaximize}
          />
        ),
        totalrevenue: item.receivable_amount,
        total: '',
      },
    ]
    return item
  })

  return (
    <>
      {data &&
        data?.map((item) => {
          return (
            <>
              <CardViewContainer>
                <CardTitleSection>
                  <SectionTitle>{item.courier_name}</SectionTitle>
                  <SectionTitle>
                    Avg. Cost:
                    <PixelCurrency value={item.avg_shipping_cost_per_order} />
                  </SectionTitle>
                </CardTitleSection>
                <CardBodySection>
                  {item.orders?.map((key) => {
                    return (
                      <>
                        <Card style={{ backgroundColor: key?.background }}>
                          <CardSection>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '50px',
                                width: '50px',
                                borderRadius: '50%',
                                padding: '0 0 10px 0',
                                backgroundColor: key?.IconBackground,
                                boxShadow:
                                  '0px 0px 9px 0px rgb(145 145 145 / 20%)',
                              }}
                            >
                              {key.logo}
                            </div>{' '}
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '10px',
                                paddingTop: '10px',
                              }}
                            >
                              {key?.total ? (
                                <>
                                  <PixelText
                                    style={{
                                      fontSize: '18px',
                                      fontWeight: '600',
                                    }}
                                    customColor={color}
                                  >
                                    {key?.total}
                                  </PixelText>
                                  <CardHeaderTitle>{key.title}</CardHeaderTitle>
                                </>
                              ) : (
                                <CardHeaderTitle>{key.title}</CardHeaderTitle>
                              )}
                            </div>
                          </CardSection>
                          <CardBody>
                            <CardSection>
                              <CardBodyContent>
                                <PixelCurrency value={key.totalrevenue} />
                              </CardBodyContent>
                            </CardSection>
                          </CardBody>
                        </Card>
                      </>
                    )
                  })}
                </CardBodySection>
              </CardViewContainer>
            </>
          )
        })}
    </>
  )
}
const CardViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 10px 0px;
`
const CardTitleSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 97%;
  margin: 10px;
`
const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: space-between;
  width: 19%;
  /* border: 1px solid #e6e6e6; */
  box-shadow: rgb(119 119 119 / 16%) 0px 0px 5px;
  border-radius: 5px;
  margin: 0px 5px 0px 5px;
  min-height: 108px;
  &:hover {
    background-color: ${colors.grayLightBg};
  }
`
const SectionTitle = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: ${(props) => props.color || colors.grayTextDark};
`
const CardSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 85%;
  margin: 8px auto;
  gap: 10px;
`
const CardBody = styled.div`
  width: 100%;
`

const CardBodyContent = styled.div`
  font-size: 14px;
  font-weight: 500;
`
const CardHeaderTitle = styled.span`
  font-size: 16px;
  color: ${colors.text};
  /* margin: 11px 0px 3px 0px; */
  font-weight: 600;
`
const CardBodySection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 4px 0px 5px 0px;
`
export default CardView
